import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import React from 'react';

import { colors, withOpacity } from '../KestrixDesignSystem.jsx';

/**
 * Reusable icon button component with consistent styling and tooltip
 * Used in toolbars, 3D viewers, and other interactive interfaces
 */
const KestrixIconButton = ({
  children,
  onClick,
  isSelected = false,
  tooltip,
  variant = 'default', // 'default', 'primary', 'secondary', 'thermal'
  size = 'medium', // 'small', 'medium', 'large'
  disabled = false,
  ...props
}) => {
  // Size configurations
  const sizeConfig = {
    small: {
      width: '32px',
      height: '32px',
      padding: '6px'
    },
    medium: {
      width: '40px',
      height: '40px', 
      padding: '8px'
    },
    large: {
      width: '48px',
      height: '48px',
      padding: '12px'
    }
  };



  const handleClick = (event) => {
    if (disabled) return;
    if (onClick) onClick(event);
  };

  const ButtonComponent = (
    <Box
      component="button"
      onClick={handleClick}
      disabled={disabled}
      sx={{
        background: isSelected ? 
          variant === 'thermal' ? '#FF8A00' :
          variant === 'primary' ? colors.primary[100] :
          variant === 'secondary' ? colors.secondary[100] :
          '#FFF' : 'transparent',
        border: 'none',
        borderRadius: 0.75,
        cursor: disabled ? 'not-allowed' : 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s ease',
        opacity: disabled ? 0.5 : 1,
        width: sizeConfig[size].width,
        height: sizeConfig[size].height,
        padding: sizeConfig[size].padding,
        filter: isSelected ? `drop-shadow(0 2px 8px ${withOpacity(colors.neutral[500], 0.18)})` : 'none',
        '&:hover': !disabled ? {
          background: isSelected ? 
            variant === 'thermal' ? '#FF8A00' :
            variant === 'primary' ? colors.primary[100] :
            variant === 'secondary' ? colors.secondary[100] :
            '#FFF' : colors.neutral[100],
          filter: `drop-shadow(0 2px 8px ${withOpacity(colors.neutral[500], 0.12)})`
        } : {},
        '&:focus': {
          outline: 'none'
        }
      }}
      {...props}
    >
      {children}
    </Box>
  );

  // Wrap with tooltip if provided
  if (tooltip) {
    return (
      <Tooltip 
        title={tooltip}
        arrow
        placement="top"
        enterDelay={500}
        leaveDelay={0}
        PopperProps={{
          sx: {
            zIndex: 9999
          }
        }}
      >
        <div style={{ display: 'inline-block' }}>
          {ButtonComponent}
        </div>
      </Tooltip>
    );
  }

  return ButtonComponent;
};

export default KestrixIconButton;
